import type { EventCategory } from './base';

export const PushEvents = {
  PUSH_SUBSCRIPTION_CREATED: {
    categories: ['analytics'] as EventCategory[],
    properties: {
      tenantId: '' as string,
      userId: '' as string,
    },
  },
  PUSH_SUBSCRIPTION_REMOVED: {
    categories: ['analytics'] as EventCategory[],
    properties: {
      tenantId: '' as string,
      userId: '' as string,
    },
  },
} as const;
